import { Navigate, useParams } from 'react-router-dom';
import { CareerApplicationForm } from 'src/features/brightsaas/components/CareerApplicationForm';
import { getCareerJob } from 'src/features/brightsaas/careers/jobsConfig';

// Renders the markdown-lite job description ("## " headings, "- " bullets,
// plain paragraphs) as template-native nk-entry markup so it inherits the
// dark theme's typography — MarkdownContent hardcodes light-page colors.
const renderDescription = (markdown: string) => {
  const blocks: React.ReactNode[] = [];
  let bullets: string[] = [];
  let key = 0;

  const flushBullets = () => {
    if (bullets.length === 0) return;
    blocks.push(
      <ul key={key++}>
        {bullets.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>,
    );
    bullets = [];
  };

  for (const rawLine of markdown.split('\n')) {
    const line = rawLine.trim();

    if (line.startsWith('- ')) {
      bullets.push(line.slice(2));
      continue;
    }
    flushBullets();

    if (line === '') continue;

    if (line.startsWith('## ')) {
      blocks.push(<h5 key={key++}>{line.slice(3)}</h5>);
      continue;
    }

    blocks.push(<p key={key++}>{line}</p>);
  }
  flushBullets();

  return blocks;
};

export function CareerDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const job = getCareerJob(slug);

  if (!job) {
    return <Navigate to="/careers" replace />;
  }

  return (
    <>
      <header className="nk-header">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xxl-7 col-lg-8">
                  <div className="position-relative text-center">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mx-auto mb-4">
                      Careers
                    </div>
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      {job.title}
                    </h2>
                    <p className="fs-8">
                      {job.location} · {job.employmentType}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry fs-8">
                    {renderDescription(job.descriptionMarkdown)}
                  </div>

                  <div className="mt-7">
                    <h5>Apply for this position</h5>
                    <p className="fs-9 text-muted">
                      Fields marked with * are required.
                    </p>
                    <CareerApplicationForm job={job} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
